
import { defineComponent, inject, ref, reactive, computed, nextTick } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";

import { useI18n } from "vue-i18n/index";
import clubService from "@/core/services/InstitutionService"
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    props: {
        setting: {
            type: Object,
            required: true,
            default: () => ({})
        },
        item: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const altura = screen.height;
        const titleDialog = ref('');
        const scrollbarRef = ref();
        const gblDialog = inject<any>('gblDialog');
        const gblAction = inject<any>('gblAction');

        const loader = ref(false);
        const ruleFormRef = ref<FormInstance>();
        const listCategorie = ref<any>([]);
        const listTypes = ref<any>([]);
        const listStatus = ref<any>([]);

        const form = reactive<any>({
            phone: []
        })
        const rules = reactive<FormRules>({})

        const listRegions: any = computed<any>(() => {
            return store.getters.currentUser.regions;
        });

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const onOpen = () => {
            form.phone = [];
            titleDialog.value = gblAction.value == 'new' ? 'Registrar institución' : 'Editar institución'
            listTypes.value = props.setting.types
            listCategorie.value = props.setting.categories
            listStatus.value = props.setting.status

            if (gblAction.value == 'edit')
                onEdit()
        }

        const onClosed = () => {
            titleDialog.value = ''
            //ruleFormRef.value?.resetFields();
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        }

        const addPhone = () => {
            form.phone.push({ type: '', countryCode: form.country?.postalcode, number: '' });
            nextTick(() => {
                if (scrollbarRef.value) {
                    scrollbarRef.value.setScrollTop(scrollbarRef.value.wrapRef.scrollHeight);
                }
            });
        };

        const removePhone = (index: number) => {
            form.phone.splice(index, 1);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    (gblAction.value == 'new') ? save() : update()

            });
        };

        const onEdit = async () => {
            loader.value = true
            await clubService.edit(props.item.idinstitution)
                .then((res) => {
                    const newPhone = Array.isArray(res.data.phone)
                    ? res.data.phone
                    : [{
                        type: '',
                        countryCode: form.country?.postalcode || '',
                        number: typeof res.data.phone === 'string' || typeof res.data.phone === 'number'
                        ? String(res.data.phone)
                        : ''
                    }];

                Object.assign(form, {
                    ...res.data,
                    phone: newPhone
                })
                    
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const save = () => {
            loader.value = true
            clubService.save(form)
                .then((res) => {
                    loader.value = false
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const update = () => {
            loader.value = true
            clubService.update(form.idinstitution, form)
                .then((res) => {
                    loader.value = false
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        return {
            t,
            altura,
            gblDialog,
            gblAction,
            titleDialog,
            ruleFormRef,
            loader,
            form,
            rules,
            listCategorie,
            listTypes,
            listRegions,
            listCountry,
            listStatus,
            scrollbarRef,
            //event
            onOpen,
            onClosed,
            addPhone,
            removePhone,
            onEdit,
            resetForm,
            submitForm,

        }

    },
})
